<span class="kr-sp-header-label" :style="dynamicStyles" v-html="content"></span>